import React from "react";
import { MarketData, MarketDataCategory } from "./stock-data-slice";

interface marketDataCardProps {
  marketData: MarketData | MarketDataCategory,
  value?: string,
  selected: boolean,
  status?: 'idle' | 'pending' | 'succeeded' | 'failed',
}

// Shorten the description, by abbreviating all but the last word. e.g. "Earnings Yield" => "E. Yield"
function shortenDescription(description: string) {
  const words = description.split(" ");
  const shortDescription = words.map((word, index) => (index === words.length - 1) ? word : `${word[0]}.`).join(" ");
  return shortDescription;
}

const MarketDataCard: React.FC<marketDataCardProps> = (props: marketDataCardProps) => {

  return (
    <div className={`flex flex-col p-1 lg:px-3 border border-white/0 rounded-lg items-center text-center justify-center
      ${props.value === undefined ? "" : "aspect-square"}
      ${!props.selected ? "text-neutral-300/70" : "text-neutral-300"}`}>

      {/** Description */}
      <div className="px-3 py-2 text-nowrap">
        {shortenDescription(props.marketData)}
      </div>

      {/** Dividing Line */}
      <div className={`w-full h-1 border-b [mask-image:linear-gradient(to_right,transparent_0,black_15%,black_85%,transparent_100%)]
        ${props.value === undefined ? "hidden" : ""}
        ${!props.selected ? "border-neutral-300/70" : "border-blue-300"}`} />

      {/** Value */}
      <div className={`grow flex items-center text-2xl lg:text-3xl
        ${props.value === undefined ? "hidden" : ""}
      `}>
        {props.value}
      </div>

    </div >
  )
}
export default MarketDataCard;